import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import { footerHeight } from '../theme';

const useStyles = makeStyles((theme) => ({
  text: {
    padding: 0,
    margin: 0,
    fontSize: 12,
    color: '#000000',
  },
  appBar: {
    top: 'auto',
    bottom: 0,
    backgroundColor: theme.palette.primary.light,
    padding: 0,
  },
  toolbar: {
    backgroundColor: theme.palette.primary.light,
    height: footerHeight,
    minHeight: footerHeight,
    overflow: 'hidden',
  },
  grow: {
    flexGrow: 1,
  },
}));

export default function Footer() {
  const classes = useStyles();

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <div className={classes.grow} />
        <Typography variant="h6" className={classes.text}>
          &copy;2021
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
